import { Component, computed, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDivider, MatListItem, MatListItemMeta, MatListItemTitle, MatNavList } from '@angular/material/list';
import { RouterLink } from '@angular/router';
import { ActiveTenantLocationStore } from '@raxapp/multi-tenants/ActiveTenantLocation.store';
import { MultiTenantStore } from '@raxapp/multi-tenants/MultiTenant.store';

interface LocationListPageLocation {
    name: string;
    id: string;
    locationRouterLink: string;
    locationSettingsRouterLink: string;
}

@Component({
    selector: 'rax-multi-tenant-location-list-page',
    imports: [MatNavList, MatDivider, MatListItem, MatListItemTitle, MatListItemMeta, MatIcon, MatIconButton, RouterLink],
    templateUrl: './location-list-page.component.html',
})
export class MultiTenantLocationListPage {
    private readonly activeTenantLocationStore = inject(ActiveTenantLocationStore);
    private readonly multiTenantStore = inject(MultiTenantStore);

    public readonly tenantIdCode = computed(() => this.activeTenantLocationStore.activeTenant()?.tenantIdCode);
    public readonly tenantName = computed(() => this.activeTenantLocationStore.activeTenant()?.tenantName);
    public readonly locations = computed<LocationListPageLocation[]>(() => {
        return (
            this.multiTenantStore
                .tenants()
                .find((tenant) => tenant.tenantIdCode === this.tenantIdCode())
                ?.locations.map(
                    (location) =>
                        ({
                            name: location.locationName,
                            id: location.locationId,
                            locationRouterLink: `/t/${this.tenantIdCode()}/l/${location.locationIdCode}`,
                            locationSettingsRouterLink: `/t/${this.tenantIdCode()}/l/${location.locationIdCode}/settings`,
                        }) as LocationListPageLocation,
                ) ?? []
        );
    });
}
